import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=81bf6da4&scoped=true&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&id=81bf6da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bf6da4",
  null
  
)

export default component.exports